import { render, staticRenderFns } from "./TrialEnded.vue?vue&type=template&id=7680adce&scoped=true"
import script from "./TrialEnded.vue?vue&type=script&lang=js"
export * from "./TrialEnded.vue?vue&type=script&lang=js"
import style0 from "./TrialEnded.vue?vue&type=style&index=0&id=7680adce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680adce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
